module.exports = __webpack_public_path__ + "static/norskfilm-90c7d94cdafaf020785459e1b3732050.png";